module.exports = __webpack_public_path__ + "media/images/core_values/creativity-7bbe8728d887bcf9f9fa0844d9f376f7.png";